import { useEffect, useState } from "react";

export const useTimleneEditor = (operation) => {
  const [toLocate, setToLocate] = useState(1);

  const updateToLocate = (currenTotLocate) => {
    setToLocate(currenTotLocate);
  };

  useEffect(() => {
    updateToLocate(1);
  }, [operation]);

  // Проверяем, есть ли настройки
  const hasSettings = operation.settings && operation.settings.length > 0;

  // Если настройки есть, устанавливаем значения, иначе используем значения по умолчанию
  const initialGroupId = hasSettings ? operation.settings[0].group_id : null;
  const [selectedGroup, setSelectedGroup] = useState(initialGroupId);
  const changeSelectedGroup = (currentGroup) => {
    setSelectedGroup(currentGroup);
  }

  // Находим настройки для выбранной группы
  const selectedSetting = hasSettings
    ? operation.settings.find((setting) => setting.group_id === selectedGroup)
    : null;

  // Устанавливаем начальное значение batchSize в пределах выбранной группы
  const initialBatchSize = selectedSetting ? selectedSetting.min : 1;
  const [batchSize, setBatchSize] = useState(initialBatchSize);
  const changeBatchSize = (curretBatchSize) => {
    setBatchSize(curretBatchSize);
  }

  // Расчет длительности при каждом изменении входных данных
  const executionTime = selectedSetting ? selectedSetting.execution_time : 0;
  const parallel = batchSize || 1; // Избегаем деления на ноль
  const totalDurationSeconds =
    toLocate > 0 ? Math.ceil(toLocate / parallel) * executionTime : 0;

  
  return {
    hasSettings,
    selectedSetting,
    toLocate,
    parallel,
    totalDurationSeconds,
    selectedGroup,
    updateToLocate,
    changeSelectedGroup,
    batchSize,
    changeBatchSize
  };
};
